import { render, staticRenderFns } from "./advisory.vue?vue&type=template&id=f70179ce&scoped=true&"
import script from "./advisory.vue?vue&type=script&lang=js&"
export * from "./advisory.vue?vue&type=script&lang=js&"
import style0 from "./advisory.vue?vue&type=style&index=0&id=f70179ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70179ce",
  null
  
)

export default component.exports